const isObject = (obj) => obj && typeof obj === 'object';

const deepClone = (o) => {
	const out = Array.isArray(o) ? [] : {};
	if (!isObject(o)) return out;
	Object.keys(o).forEach((key) => {
		const v = o[key];
		out[key] = isObject(v) ? deepClone(v) : v;
	});
	return out;
};

const deepMerge = (...objects) => (
	objects.reduce((prev, obj) => {
		Object.keys(obj).forEach((key) => {
			const pVal = prev[key];
			const oVal = obj[key];

			if (Array.isArray(pVal) && Array.isArray(oVal)) {
				prev[key] = [...pVal, ...oVal].filter((element, index, array) => array.indexOf(element) === index);
			} else if (isObject(pVal) && isObject(oVal)) {
				prev[key] = deepMerge(pVal, oVal);
			} else {
				prev[key] = oVal;
			}
		});

		return prev;
	}, {})
);

const deepCompare = (obj1, obj2) => {
	let isEqual = true;

	if (obj2 === undefined) return false;

	Object.keys(obj1).forEach((p) => {
		switch (typeof (obj1[p])) {
			case 'object':
				if (!deepCompare(obj1[p], obj2[p])) isEqual = false;
				break;
			default:
				if (obj1[p] !== obj2[p]) isEqual = false;
		}
	});

	Object.keys(obj2).forEach((p) => {
		if (typeof (obj1[p]) === 'undefined') isEqual = false;
	});

	return isEqual;
};

export { deepClone, deepMerge, deepCompare };
